<template>
  <div class="flex flex-wrap flex-col pb-24 pt-16">
    <h2 class="text-dark text-center">Тарифы</h2>
    <div class="tarif-wrapper">
      <div class="flex flex-wrap flex-col pb-12 pt-6 tarif-box">
        <h3 class="text-primary pb-6">Пакет Старт</h3>
        <div class="flex flex-wrap flex-col md:flex-row md:flex-row-reverse md:justify-end md:content-center block-wrap">
          <img class="w-80 h-80 md:ml-10" src="@/assets/images/tariffs/start.svg" alt="image" />
          <ul class="pt-6 tariff-list">
            <li class="pb-4">Бесплатных платежей в тарифе: 80</li>
            <li class="pb-4">Доступен в течение первых 2-х месяцев</li>
            <li class="pb-4">Бесплатных проверок контрагентов в тарифе: 1 в тарифе</li>
            <li class="pb-4">Бесплатная банковская бизнес-карта: 1 в тарифе</li>
            <li class="pb-4">Снятие наличных в кассе до 50 000TJS - бесплатно, более - 1%</li>
            <li class="pb-4">Снятие наличных в кассе (эквивалент до 1 000$) - бесплатно, более  - 1,5%</li>
            <li class="pb-4">Зарплатный проект, от суммы перечислений - 0%</li>
            <!-- TODO: добавить эту строку -->
            <li class="pb-4">Входящие валютные переводы, (премия клиентам) - 0,2% руб./0,1% $</li>
          </ul>
        </div>
        <div class="pt-6 pb-6 font-semibold">Стоимость в месяц 0 TJS</div>
        <div class="buttons-wrap">
          <button class="buttons__btn text-primary font-medium">Перейти</button>
          <a class="buttons__btn text-primary font-medium" href="#">Сравнить</a>
        </div>
      </div>
      <div class="flex flex-wrap flex-col pb-12 pt-6 tarif-box">
        <h3 class="text-primary pb-6">Пакет Стандарт</h3>
        <div class="flex flex-col md:flex-row block-wrap">
          <img class="w-80 h-80 md:mr-10" src="@/assets/images/tariffs/standart.svg" alt="image" />
          <ul class="pt-6 tariff-list">
            <li class="pb-4">Бесплатных платежей в тарифе: 20</li>
            <li class="pb-4">Обслуживание РКО - 0 TJS при неснижаемом остатке 50 000TJS</li>
            <li class="pb-4">Бесплатных проверок контрагентов в тарифе: 1 в тарифе</li>
            <li class="pb-4">Бесплатная банковская бизнес-карта: 1 в тарифе</li>
            <li class="pb-4">Снятие наличных в кассе до 50 000TJS - бесплатно, остальное  - 0,8%</li>
            <li class="pb-4">Снятие наличных в кассе (эквивалент до 1 000$) - бесплатно, более  - 1,5%</li>
            <li class="pb-4">Зарплатный проект, от суммы перечислений - 0,7%</li>
            <!-- TODO: добавить эту строку -->
            <li class="pb-4">Входящие валютные переводы, (премия клиентам) - 0,2% руб./0,1% $</li>
          </ul>
        </div>
        <div class="pt-6 pb-6 font-semibold">Стоимость в месяц 149 TJS</div>
        <div class="buttons-wrap">
          <button class="buttons__btn text-primary font-medium">Перейти</button>
          <a class="buttons__btn text-primary font-medium" href="#">Сравнить</a>
        </div>
      </div>
      <div class="flex flex-wrap flex-col pb-12 pt-6 tarif-box">
        <h3 class="text-primary pb-6">Пакет Бизнес</h3>
        <div class="flex flex-wrap flex-col md:flex-row md:flex-row-reverse md:justify-end md:content-center block-wrap">
          <img class="w-80 h-80 md:ml-10" src="@/assets/images/tariffs/business.svg" alt="image" />
          <ul class="pt-6 tariff-list">
            <li class="pb-4">Бесплатных платежей в тарифе: 50</li>
            <li class="pb-4">Обслуживание РКО - 0 TJS при неснижаемом остатке 150 000TJS</li>
            <li class="pb-4">Бесплатных проверок контрагентов в тарифе: 2 в тарифе</li>
            <li class="pb-4">Бесплатная банковская бизнес-карта: 2 в тарифе</li>
            <li class="pb-4">Снятие наличных в кассе до 80 000TJS - бесплатно, остальное  - 0,7%</li>
            <li class="pb-4">Снятие наличных в кассе (эквивалент до 2 000$) - бесплатно, более  - 1,3%</li>
            <li class="pb-4">Зарплатный проект, от суммы перечислений - 0,6%</li>
            <!-- TODO: добавить эту строку -->
            <li class="pb-4">Входящие валютные переводы, (премия клиентам) - 0,3% руб./0,15% $</li>
          </ul>
        </div>
        <div class="pt-6 pb-6 font-semibold">Стоимость в месяц 349 TJS</div>
        <div class="buttons-wrap">
          <button class="buttons__btn text-primary font-medium">Перейти</button>
          <a class="buttons__btn text-primary font-medium" href="#">Сравнить</a>
        </div>
      </div>
      <div class="flex flex-wrap flex-col pb-12 pt-6 tarif-box">
        <h3 class="text-primary pb-6">Пакет Бизнес +</h3>
        <div class="flex flex-col md:flex-row block-wrap">
          <img class="w-80 h-80 md:mr-10" src="@/assets/images/tariffs/businessplus.svg" alt="image" />
          <ul class="pt-6 tariff-list">
            <li class="pb-4">Бесплатных платежей в тарифе: 150</li>
            <li class="pb-4">Обслуживание РКО - 0 TJS при неснижаемом остатке 350 000TJS</li>
            <li class="pb-4">Бесплатных проверок контрагентов в тарифе: 5 в тарифе</li>
            <li class="pb-4">Бесплатная банковская бизнес-карта: 5 в тарифе</li>
            <li class="pb-4">Снятие наличных в кассе до 100 000TJS - бесплатно, остальное  - 0,6%</li>
            <li class="pb-4">Снятие наличных в кассе (эквивалент до 5 000$) - бесплатно, более  - 1%</li>
            <li class="pb-4">Зарплатный проект, от суммы перечислений - 0,5%</li>
            <!-- TODO: добавить эту строку -->
            <li class="pb-4">Входящие валютные переводы, (премия клиентам) - 0,5% руб./0,25% $</li>
          </ul>
        </div>
        <div class="pt-6 pb-6 font-semibold">Стоимость в месяц 899 TJS</div>
        <div class="buttons-wrap">
          <button class="buttons__btn text-primary font-medium">Перейти</button>
          <a class="buttons__btn text-primary font-medium" href="#">Сравнить</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AllTariffsT'
}
</script>

<style scoped>

</style>

